/**
 * @module app.um
*/

import { autoinject } from 'aurelia-framework';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { AuthService } from 'app/um/services/auth-service';
import { apiCall } from 'app/shared/lib/api/api';
import { IAuthAuditLogModelData } from 'app/um/components/audit-log/auth-audit-log';
import * as UM from 'app/um/models/essette-api'

@autoinject()
export class AuthAuditLogPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected auth: UM.Auth | null = null;
    protected modelData: IAuthAuditLogModelData | null = null;

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly authService: AuthService,
        private readonly i18n: I18N,
        ...rest: any[]) {

        super(...rest);
    }

    protected async canActivate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<boolean> {
        await this.accountContext.load();
        return this.accountContext.hasRouteAccess('um.auth.audit-log');
    }

    protected async activate(params: { authId: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params?.authId) throw new Error('Missing required parameters: authId');

        await this.reload(params.authId);

        if(this.auth && routeConfig?.navModel) {
            const title = this.i18n.tr('um:routes.auth.audit-log.$title', { number: this.auth.number });
            routeConfig.navModel.setTitle(title);
        }
    }

    ////****************** Events ***************************************************////
    protected async reload(authId: string): Promise<void> {
        if(!authId) return;

        await this.loadAuth(authId);
        if(!this.auth) {
            throw new Error('Unable to load auth');
        }

        this.modelData = {
            auth: this.auth
        };
    }

    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAuth(authId: string): Promise<void> {
        if(!authId) return;

        try {
            this.state.beginLoad();

            const response = await this.authService.loadAuth(authId);
            this.auth = response.results[0];
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }
}
